import hcSticky from 'hc-sticky';
import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
    new hcSticky('.home-banner-block-vertical-title', {
        top: 120,
    });
});

const wrapper = $('.home-banner-block-mobile-image');
const setContainerWidth = () => {
    const bodyWidth = $('body').outerWidth();

    if (window.matchMedia('(max-width: 991.98px)').matches) {
        wrapper.css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    } else {
        wrapper.css({
            width: '',
            marginLeft: '',
        });
    }
};

$(window).bind('resize', setContainerWidth).trigger('resize');
